const SITE_ID = 5;const SITE_UID='dabffc65-2820-43cc-bea4-09eeaa5d34fb';const SUBDOMAIN='masan';export { SITE_ID, SITE_UID, SUBDOMAIN }